import script from "./MenuItemv2.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuItemv2.vue?vue&type=script&setup=true&lang=js"

import "./MenuItemv2.vue?vue&type=style&index=0&id=a8ece788&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8ece788"]])

export default __exports__